import React from "react";
import { AuthForm } from "apps/auth/components";
import { Button, FileField, InputField, PasswordField } from "components/ui";
import { withRouter } from "react-router-dom";
import { CONSTANTS } from "shared/constants";
import {
  notEmpty,
  notSpecialCharacters,
  notSpaces,
  passVal,
} from "shared/utils/input-validations";
import { useTranslation } from "react-i18next";
import { connectReduxReducers } from "hocs";
const SignupCompanyPage = ({ auth, organizations, history }) => {
  const [success] = React.useState(false);
  const { t } = useTranslation();

  const passregex = /^(?=.*?[A-Z])(?=.*?[a-z]).{8,}$/;

  const goToLogin = () => {
    history.push(CONSTANTS.URLS.AUTH.LOGIN);
  };

  const navbarActions = (
    <>
      <h5>{t("navbar.login_span")}</h5>
      <Button
        primary
        thin
        onClick={() => {
          history.push(CONSTANTS.URLS.AUTH.LOGIN);
        }}
      >
        {t("navbar.login")}
      </Button>
    </>
  );

  const onSubmit = (data) => {
    if (data.password.match(passregex)) {
      organizations.signupOrganization(data, (response) => {
        if (response.status === 201) {
          auth.login(
            {
              username: data.username,
              password: data.password,
            },
            (response) => {
              if (response.status === 200) {
                organizations.sendActiveAccount(
                  {
                    organization_id: response.data.user.organization.id,
                  },
                  (response) => {
                    if (response.status === 201) {
                    }
                  }
                );
              }
            }
          );
        }
      });
    }
  };

  if (success) {
    return (
      <AuthForm
        navbarActions={navbarActions}
        onSubmit={onSubmit}
        title="¡Excelente!"
        message="Tu registro ha sido exitoso. Bienvenido a la comunidad de Panzofi, esperamos que participes activamente."
      >
        {() => (
          <React.Fragment>
            <dl>
              <dt>
                {" "}
                <h5>Te invitamos a ver el siguiente enlace: </h5>
              </dt>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={"https://panzofi.com/cursos/tutorial-panzofi"}
              >
                <h5>--- Tutorial Panzofi ---</h5>
              </a>
            </dl>
            <h5>Vuelve a iniciar sesión para comenzar</h5>
            <section className="pz-auth-form__buttons">
              <Button type="button" ghost secondary onClick={goToLogin}>
                Volver a iniciar sesión
              </Button>
            </section>
          </React.Fragment>
        )}
      </AuthForm>
    );
  }

  return (
    <AuthForm
      navbarActions={navbarActions}
      onSubmit={onSubmit}
      title={t("register.title")}
    >
      {({ onChange }) => (
        <React.Fragment>
          <FileField
            errMsg={t(`profile.modal.file_input.error`)}
            nameDefault={t(`profile.modal.file_input.state`)}
            label={t(`profile.modal.file_input.title`)}
            name="logo"
            onChange={onChange}
            notRequired
          />
          <InputField
            label={"Nombre de la empresa"}
            name="first_name"
            onChange={onChange}
            validations={[notEmpty, notSpecialCharacters]}
            required
          />
          <InputField
            label={t("register.user")}
            name="username"
            onChange={onChange}
            validations={[notEmpty, notSpecialCharacters, notSpaces]}
            required
          />
          <InputField
            label={t("register.email")}
            name="email"
            onChange={onChange}
            type="email"
            validations={[notEmpty, notSpaces]}
            required
          />
          <InputField
            label={"Sitio web"}
            name="website"
            onChange={onChange}
            type="url"
            validations={[notEmpty, notSpaces]}
            required
          />
          <PasswordField
            label={t("register.password")}
            name="password"
            onChange={onChange}
            validations={[notEmpty, notSpaces, passVal]}
            required
          />
          <dl>
            <dd>
              {" "}
              <h6>{t("register.terms1")}</h6>
            </dd>
            <dd>
              {" "}
              <h6>{t("register.terms2")}</h6>
            </dd>
            <dd>
              {" "}
              <h6>{t("register.terms3")}</h6>
            </dd>
          </dl>
          <section className="pz-auth-form__buttons">
            <Button type="submit" primary>
              {t("register.button")}
            </Button>
          </section>
        </React.Fragment>
      )}
    </AuthForm>
  );
};

export default withRouter(
  connectReduxReducers(SignupCompanyPage, "organizations")
);
